Foundation.version = null;
FOUNDATION_VERSION = null;
jQuery.fn.jquery = null;
$().jquery = null;
$.fn.jquery = null;
